/* istanbul ignore next */
export var global = typeof window !== 'undefined' ? window : {};
